export default "__VITE_ASSET__DGmWx_cB__ 400w, __VITE_ASSET__Bt9nULne__ 800w, __VITE_ASSET__DpmRPtDM__ 1024w";